export default __webpack_public_path__ + "static/media/Glade2 - Logo.c12e39a2.png";